import React from 'react';
import {
  PollRounded as PollRoundedIcon,
  MonetizationOn as MonetizationOnIcon,
  Today as TodayIcon,
  PinDropRounded as PinDropRoundedIcon,
  DashboardOutlined as DashboardOutlinedIcon,
  PostAddRounded as PostAddRoundedIcon,
  DriveEtaOutlined as DriveEtaOutlinedIcon,
  Commute as CommuteIcon,
  EmojiTransportation as EmojiTransportationIcon,
  WidgetsOutlined as WidgetsOutlinedIcon,
  FormatListBulletedRounded as FormatListBulletedRoundedIcon,
  LocalGasStationOutlined as LocalGasStationOutlinedIcon,
  QueueOutlined as QueueOutlinedIcon,
  AssignmentOutlined as AssignmentOutlinedIcon,
  ExitToAppRounded as ExitToAppRoundedIcon,
  HomeOutlined as HomeOutlinedIcon,
  Assignment as AssignmentIcon,
  People as PeopleIcon,
  Category as CategoryIcon,
  Build as BuildIcon,
  Person as PersonIcon,
  Map as MapIcon,
  SupervisorAccount as SupervisorAccountIcon,
  AccountBalance as AccountBalanceIcon,
  AccountBalanceWallet as AccountBalanceWalletIcon,
  Description as DescriptionIcon,
  Receipt as ReceiptIcon,
  Business as BusinessIcon,
  Event as EventIcon,
  Public as PublicIcon,
  Forum as ForumIcon,
  Message as MessageIcon,
  Send as SendIcon,
  Chat as ChatIcon,
  Group as GroupIcon,
  Hotel as HotelIcon,
  ContactSupport as ContactSupportIcon,
  Schedule as ScheduleIcon,
  //GroupWorkOutlinedIcon as GroupWorkOutlinedIcon
} from '@material-ui/icons';
import GroupWorkOutlinedIcon from '@material-ui/icons/GroupWorkOutlined';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';
import { PERMS } from './permissions';
import {
  AMODULO_RECEPTIVO,
  AMODULO_FROTAS,
  AMODULO_GERENCIAL,
  AMODULO_FINANCAS,
  AMODULO_CRM,
  AMODULO_PARTNER,
  AMODULO_ADMAPPCLI
} from './consts';

import {
  Dashboard as DashboardView,
  Login as LoginView,
  Logout as LogoutView,
  MenuAdministrativo as MenuAdministrativoView,
  MenuFinanceiro as MenuFinanceiroView,
  MenuOperacional as MenuOperacionalView,
  MenuProducao as MenuProducaoView,

  // Frotas
  MarcaVeiculoList as MarcaVeiculoView,
  ModeloVeiculoList as ModeloVeiculoView,
  TipoVeiculoList as TipoVeiculoView,
  VeiculoList as VeiculoView,
  OpcionalVeiculoList as OpcionalVeiculoView,
  AbastecimentoList as AbastecimentoView,
  OsManutVeiculoList as OsManutVeiculoListView,

  // Front
  OS as OSView,
  OSList as OSListView,
  FormPax as FormPaxView,
  MapaOperacao as MapaOperacaoView,
  UserList as UserListView,
  CategoriaServicoList as CategoriaServicoListView,
  ServicoList as ServicoListView,
  MotivoCancelamentoList as MotivoCancelamentoView,
  VendedorList as VendedorListView,
  ClienteList as ClienteListView,

  // Finanças
  BancoList as BancoListView,
  ContaCorrenteList as ContaCorrenteListView,
  FeriadoList as FeriadoListView,
  HistoricoBancarioList as HistoricoBancarioView,
  PaisList as PaisListView,
  SetorList as SetorListView,
  TipoDocumentoList as TipoDocumentoView,
  TransacaoFinanceiraList as TransacaoFinanceiraListView,
  FechamentoFinanceiroForm,

  // CRM
  GrupoMsgWhatsAppFornecedor,
  MsgWhatsAppFornecedorList,

  // AppCli / AdmAppCli
  MenuProgramacao as MenuProgramacaoView,
  Hospedagem as HospedagemView,
  FaleConosco as FaleConoscoView,
  LoginAppCli as LoginAppCliView,
  AdmSisarePassengerForm,
  AdmSisarePassengerGuidance,
  AdmSisarePassengerRoom,

  // Partner / AdmPartner
  AgendaEscalaFornecedorList as AgendaEscalaFornecedorListView,
  UsuarioPartnerList as UsuarioPartnerListView
} from './views';

// Frotas Forms
import MarcaVeiculoForm from 'views/Frotas/MarcaVeiculo/MarcaVeiculoForm';
import ModeloVeiculoForm from 'views/Frotas/ModeloVeiculo/ModeloVeiculoForm';
import TipoVeiculoForm from 'views/Frotas/TipoVeiculo/TipoVeiculoForm';
import VeiculoForm from 'views/Frotas/Veiculo/VeiculoForm';
import OpcionalVeiculoForm from 'views/Frotas/OpcionalVeiculo/OpcionalVeiculoForm';
import AbastecimentoForm from 'views/Frotas/Abastecimento/AbastecimentoForm';
import OsManutVeiculoForm from 'views/Frotas/OsManutVeiculo/OsManutVeiculoForm';

// Front Forms
import CategoriaServicoForm from 'views/Front/CategoriaServico/CategoriaServicoForm';
import ServicoForm from 'views/Front/Servico/ServicoForm';
import MotivoCancelamentoForm from 'views/Front/MotivoCancelamento/MotivoCancelamentoForm';
import VendedorForm from 'views/Front/Vendedor/VendedorForm';

// Finanças Forms
import BancoForm from 'views/Financas/Banco/BancoForm';
import ContaCorrenteForm from 'views/Financas/ContaCorrente/ContaCorrenteForm';
import HistoricoBancarioForm from 'views/Financas/HistoricoBancario/HistoricoBancarioForm';
import TransacaoFinanceiraForm from 'views/Financas/TransacaoFinanceira/TransacaoFinanceiraForm';
import TipoDocumentoForm from 'views/Financas/TipoDocumento/TipoDocumentoForm';
import SetorForm from 'views/Financas/Setor/SetorForm';
import FechamentoFinanceiroList from 'views/Financas/FechamentoFinanceiro/FechamentoFinanceiroList';
import PaisForm from 'views/Geral/Pais/PaisForm';
import FeriadoForm from 'views/Geral/Feriado/FeriadoForm';

// CRM Forms
import WhatsAppChat from 'views/CRM/WhatsApp/WhatsAppChat';
import WhatsAppFornecedorForm from 'views/CRM/WhatsApp/WhatsAppFornecedorForm';
import MsgWhatsAppFornecedorForm from 'views/CRM/WhatsApp/MsgWhatsAppFornecedorForm';
import GrupoMsgWhatsAppFornecedorForm from 'views/CRM/WhatsApp/GrupoMsgWhatsAppFornecedorForm';

// AdmAppCli
import AdmSisarePassengerList from 'views/AdmAppCli/AdmSisarePassengerList';

// Partner / AdmPartner
import AgendaEscalaFornecedorForm from 'views/Partner/AgendaEscalaFornecedor/AgendaEscalaFornecedorForm';
import LoginPartner from 'views/Partner/Login/LoginPartner';
import UsuarioPartnerForm from 'views/AdmPartner/UsuarioPartner/UsuarioPartnerForm';

/**
 * Observação:
 * - Aqui entram todas as rotas navegáveis do sistema.
 * - requiredPerm = permissão para acesso da rota.
 * - requiredPerm = 0 => rota protegida apenas por login/módulo.
 * - permissões internas de botões, abas e recursos continuam dentro das telas.
 */
export const appRoutes = [
  // =========================
  // PÚBLICAS GERAIS
  // =========================
  {
    path: '/login',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/logout',
    exact: true,
    component: LogoutView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },

  // =========================
  // GERENCIAL
  // =========================
  {
    path: '/gerencial',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/gerencial/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/gerencial/menuproducao',
    exact: true,
    component: MenuProducaoView,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_PRODUCAO,
    authType: 'internal'
  },
  {
    path: '/gerencial/menuoperacional',
    exact: true,
    component: MenuOperacionalView,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_OPERACIONAL,
    authType: 'internal'
  },
  {
    path: '/gerencial/menufinanceiro',
    exact: true,
    component: MenuFinanceiroView,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_FINANCEIRO,
    authType: 'internal'
  },
  {
    path: '/gerencial/menuadministrativo',
    exact: true,
    component: MenuAdministrativoView,
    layout: MainLayout,
    moduleCode: AMODULO_GERENCIAL,
    requiredPerm: PERMS.GERENCIAL_MENU_ADMINISTRATIVO,
    authType: 'internal'
  },

  // =========================
  // FROTAS
  // =========================
  {
    path: '/frotas',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/frotas/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/frotas/veiculo',
    exact: true,
    component: VeiculoView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/veiculo/:id',
    component: VeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/marcaveiculo',
    exact: true,
    component: MarcaVeiculoView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_MARCA_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/marcaveiculo/:id',
    component: MarcaVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_MARCA_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/modeloveiculo',
    exact: true,
    component: ModeloVeiculoView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_MODELO_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/modeloveiculo/:id',
    component: ModeloVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_MODELO_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/tipoveiculo',
    exact: true,
    component: TipoVeiculoView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_TIPO_DE_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/tipoveiculo/:id',
    component: TipoVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_TIPO_DE_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/opcionalveiculo',
    exact: true,
    component: OpcionalVeiculoView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_OPCIONAL_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/opcionalveiculo/:id',
    component: OpcionalVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_CADASTRO_OPCIONAL_VEICULO,
    authType: 'internal'
  },
  {
    path: '/frotas/abastecimento',
    exact: true,
    component: AbastecimentoView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTO_ABASTECIMENTO,
    authType: 'internal'
  },
  {
    path: '/frotas/abastecimento/:id',
    component: AbastecimentoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTO_ABASTECIMENTO,
    authType: 'internal'
  },
  {
    path: '/frotas/osmanutveiculo',
    exact: true,
    component: OsManutVeiculoListView,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTO_OS_MANUTENCAO,
    authType: 'internal'
  },
  {
    path: '/frotas/osmanutveiculo/:id',
    component: OsManutVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_FROTAS,
    requiredPerm: PERMS.FROTAS_MENU_PROCEDIMENTO_OS_MANUTENCAO,
    authType: 'internal'
  },

  // =========================
  // FRONT / RECEPTIVO
  // =========================
  {
    path: '/front',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/front/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/oss',
    exact: true,
    component: OSListView,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/os/:id',
    component: OSView,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/pax/:id',
    exact: true,
    component: FormPaxView,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/mapaoperacao',
    exact: true,
    component: MapaOperacaoView,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/users',
    exact: true,
    component: UserListView,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/categoriasservicos',
    exact: true,
    component: CategoriaServicoListView,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/categoriasservicos/:id',
    component: CategoriaServicoForm,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/servicos',
    exact: true,
    component: ServicoListView,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/servicos/:id',
    component: ServicoForm,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/motivoscancelamentos',
    exact: true,
    component: MotivoCancelamentoView,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/motivoscancelamentos/:id',
    component: MotivoCancelamentoForm,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/vendedores',
    exact: true,
    component: VendedorListView,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/vendedores/:id',
    component: VendedorForm,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/clientes',
    exact: true,
    component: ClienteListView,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/tipoveiculo',
    exact: true,
    component: TipoVeiculoView,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/front/tipoveiculo/:id',
    component: TipoVeiculoForm,
    layout: MainLayout,
    moduleCode: AMODULO_RECEPTIVO,
    requiredPerm: 0,
    authType: 'internal'
  },

  // =========================
  // FINANÇAS
  // =========================
  {
    path: '/financas',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/financas/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_FINANCAS,
    requiredPerm: 0,
    authType: 'internal'
  },

  // =========================
  // CRM
  // =========================
  {
    path: '/crm',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/crm/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_CRM,
    requiredPerm: 0,
    authType: 'internal'
  },

  // =========================
  // APPCLI
  // =========================
  {
    path: '/appcli/login',
    exact: true,
    component: LoginAppCliView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'passenger'
  },
  {
    path: '/appcli',
    exact: true,
    component: LoginAppCliView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'passenger'
  },
  {
    path: '/appcli/programacao',
    exact: true,
    component: MenuProgramacaoView,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/hospedagem',
    exact: true,
    component: HospedagemView,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/faleconosco',
    exact: true,
    component: FaleConoscoView,
    layout: MainLayout,
    authType: 'passenger',
    redirectTo: '/appcli'
  },
  {
    path: '/appcli/:localizador',
    exact: true,
    component: LoginAppCliView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  // =========================
  // ADM APP CLI
  // =========================
  {
    path: '/admappcli',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/admappcli/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admappcli/adm-sisare-passenger-list',
    exact: true,
    component: AdmSisarePassengerList,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admappcli/adm-sisare-passenger/:id',
    exact: true,
    component: AdmSisarePassengerForm,
    layout: MainLayout,
    moduleCode: AMODULO_ADMAPPCLI,
    requiredPerm: 0,
    authType: 'internal'
  },

  // =========================
  // PARTNER EXTERNO
  // =========================
  {
    path: '/partner',
    exact: true,
    component: LoginPartner,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/partner/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal',
    redirectTo: '/partner'
  },
  {
    path: '/partner/agendaescalafornecedor',
    exact: true,
    component: AgendaEscalaFornecedorListView,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'partner',
    redirectTo: '/partner'
  },
  {
    path: '/partner/agendaescalafornecedor',
    exact: true,
    component: AgendaEscalaFornecedorListView,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'partner',
    redirectTo: '/partner'
  },
  
  {
    path: '/partner/agendaescalafornecedor/:id',
    component: AgendaEscalaFornecedorForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'partner',
    redirectTo: '/partner'
  },

  {
    path: '/admpartner/agendaescalafornecedor/:id',
    component: AgendaEscalaFornecedorForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal',
    redirectTo: '/admpartner'
  },
 
  // =========================
  // ADM PARTNER INTERNO
  // =========================
  {
    path: '/admpartner',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  },
  {
    path: '/admpartner/dashboard',
    exact: true,
    component: DashboardView,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admpartner/agendaescalafornecedor',
    exact: true,
    component: AgendaEscalaFornecedorListView,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal'
  },

  {
    path: '/admpartner/usuariopartner',
    exact: true,
    component: UsuarioPartnerListView,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal'
  },
  {
    path: '/admpartner/usuariopartner/:id',
    component: UsuarioPartnerForm,
    layout: MainLayout,
    moduleCode: AMODULO_PARTNER,
    requiredPerm: 0,
    authType: 'internal'
  }, 
  
  // =========================
  // ESTOQUE
  // =========================
  {
    path: '/estoque',
    exact: true,
    component: LoginView,
    layout: MinimalLayout,
    isPublic: true,
    authType: 'public'
  }
];
/**
 * Estrutura central de menu por módulo.
 *
 * Convenções:
 * - labelKey: chave de tradução
 * - fallbackLabel: texto padrão se não houver tradução
 * - permCode: permissão para exibir item de menu
 * - itens sem permCode aparecem para usuários logados no módulo
 *
 * OBS:
 * - permissões internas de tela (botões, abas, ações) NÃO ficam aqui.
 * - isso aqui é apenas navegação.
 */
export const menuByModule = {
  [AMODULO_GERENCIAL]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: HomeOutlinedIcon,
      to: '/gerencial/dashboard'
    },
    {
      key: 'producao',
      labelKey: 'MENU_PRODUCAO',
      fallbackLabel: 'Produção',
      icon: PollRoundedIcon,
      to: '/gerencial/menuproducao',
      permCode: PERMS.GERENCIAL_MENU_PRODUCAO
    },
    {
      key: 'operacional',
      labelKey: 'MENU_OPERACIONAL',
      fallbackLabel: 'Operacional',
      icon: PinDropRoundedIcon,
      to: '/gerencial/menuoperacional',
      permCode: PERMS.GERENCIAL_MENU_OPERACIONAL
    },
    {
      key: 'financeiro',
      labelKey: 'MENU_FINANCEIRO',
      fallbackLabel: 'Financeiro',
      icon: MonetizationOnIcon,
      to: '/gerencial/menufinanceiro',
      permCode: PERMS.GERENCIAL_MENU_FINANCEIRO
    },
    {
      key: 'administrativo',
      labelKey: 'MENU_ADMINISTRATIVO',
      fallbackLabel: 'Administrativo',
      icon: TodayIcon,
      to: '/gerencial/menuadministrativo',
      permCode: PERMS.GERENCIAL_MENU_ADMINISTRATIVO
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ],

  [AMODULO_FROTAS]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlinedIcon,
      to: '/frotas/dashboard'
    },
    {
      key: 'cadastro',
      labelKey: 'MENU_ITEM_CADASTRO',
      fallbackLabel: 'Cadastro',
      icon: PostAddRoundedIcon,
      children: [
        {
          key: 'veiculos-root',
          labelKey: 'MENU_VEICULOS',
          fallbackLabel: 'Veículos',
          icon: DriveEtaOutlinedIcon,
          children: [
            {
              key: 'veiculo',
              labelKey: 'MENU_VEICULOS',
              fallbackLabel: 'Veículos',
              icon: DriveEtaOutlinedIcon,
              to: '/frotas/veiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_VEICULO
            },
            {
              key: 'marcas',
              labelKey: 'MENU_MARCAS',
              fallbackLabel: 'Marcas',
              icon: CommuteIcon,
              to: '/frotas/marcaveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_MARCA_VEICULO
            },
            {
              key: 'modelos',
              labelKey: 'MENU_MODELOS',
              fallbackLabel: 'Modelos',
              icon: EmojiTransportationIcon,
              to: '/frotas/modeloveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_MODELO_VEICULO
            },
            {
              key: 'tipos',
              labelKey: 'MENU_TIPOS',
              fallbackLabel: 'Tipos',
              icon: WidgetsOutlinedIcon,
              to: '/frotas/tipoveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_TIPO_DE_VEICULO
            },
            {
              key: 'opcionais',
              labelKey: 'MENU_OPCIONAIS',
              fallbackLabel: 'Opcionais',
              icon: WidgetsOutlinedIcon,
              to: '/frotas/opcionalveiculo',
              permCode: PERMS.FROTAS_MENU_CADASTRO_OPCIONAL_VEICULO
            }
          ]
        }
      ]
    },
    {
      key: 'procedimentos',
      labelKey: 'MENU_PROCEDIMENTOS',
      fallbackLabel: 'Procedimentos',
      icon: FormatListBulletedRoundedIcon,
      children: [
        {
          key: 'abastecimentos-root',
          labelKey: 'MENU_ABASTECIMENTOS',
          fallbackLabel: 'Abastecimentos',
          icon: LocalGasStationOutlinedIcon,
          children: [
            {
              key: 'abastecimento-lancar',
              labelKey: 'MENU_LANCAR',
              fallbackLabel: 'Lançar',
              icon: QueueOutlinedIcon,
              to: '/frotas/abastecimento',
              permCode: PERMS.FROTAS_MENU_PROCEDIMENTO_ABASTECIMENTO
            }
          ]
        },
        {
          key: 'osmanutencao-root',
          labelKey: 'MENU_OS_MANUTENCAO',
          fallbackLabel: 'OS de Manutenção',
          icon: AssignmentOutlinedIcon,
          children: [
            {
              key: 'osmanutencao-lancar',
              labelKey: 'MENU_LANCAR',
              fallbackLabel: 'Lançar',
              icon: QueueOutlinedIcon,
              to: '/frotas/osmanutveiculo',
              permCode: PERMS.FROTAS_MENU_PROCEDIMENTO_OS_MANUTENCAO
            }
          ]
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ],

  [AMODULO_RECEPTIVO]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlinedIcon,
      to: '/front/dashboard'
    },
    {
      key: 'operacao',
      labelKey: 'MENU_OPERACAO',
      fallbackLabel: 'Operação',
      icon: AssignmentIcon,
      children: [
        {
          key: 'oss',
          labelKey: 'MENU_ORDENS_SERVICO',
          fallbackLabel: 'Ordens de Serviço',
          icon: AssignmentIcon,
          to: '/front/oss'
        },
        {
          key: 'mapaoperacao',
          labelKey: 'MENU_MAPA_OPERACAO',
          fallbackLabel: 'Mapa de Operação',
          icon: MapIcon,
          to: '/front/mapaoperacao'
        }
      ]
    },
    {
      key: 'cadastro',
      labelKey: 'MENU_ITEM_CADASTRO',
      fallbackLabel: 'Cadastro',
      icon: PostAddRoundedIcon,
      children: [
        {
          key: 'clientes',
          labelKey: 'MENU_CLIENTES',
          fallbackLabel: 'Clientes',
          icon: PeopleIcon,
          to: '/front/clientes'
        },
        {
          key: 'usuarios',
          labelKey: 'MENU_USUARIOS',
          fallbackLabel: 'Usuários',
          icon: SupervisorAccountIcon,
          to: '/front/users'
        },
        {
          key: 'categorias-servicos',
          labelKey: 'MENU_CATEGORIAS_SERVICOS',
          fallbackLabel: 'Categorias de Serviços',
          icon: CategoryIcon,
          to: '/front/categoriasservicos'
        },
        {
          key: 'servicos',
          labelKey: 'MENU_ITEM_SERVICOS',
          fallbackLabel: 'Serviços',
          icon: BuildIcon,
          to: '/front/servicos'
        },
        {
          key: 'motivoscancelamentos',
          labelKey: 'MENU_MOTIVOS_CANCELAMENTO',
          fallbackLabel: 'Motivos de Cancelamento',
          icon: AssignmentOutlinedIcon,
          to: '/front/motivoscancelamentos'
        },
        {
          key: 'vendedores',
          labelKey: 'MENU_VENDEDORES',
          fallbackLabel: 'Vendedores',
          icon: PersonIcon,
          to: '/front/vendedores'
        },
        {
          key: 'tipoveiculo',
          labelKey: 'MENU_TIPO_VEICULO',
          fallbackLabel: 'Tipo de Veículo',
          icon: DriveEtaOutlinedIcon,
          to: '/front/tipoveiculo'
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ],

  [AMODULO_FINANCAS]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlinedIcon,
      to: '/financas/dashboard'
    },
    {
      key: 'cadastros',
      labelKey: 'MENU_ITEM_CADASTRO',
      fallbackLabel: 'Cadastros',
      icon: PostAddRoundedIcon,
      children: [
        {
          key: 'historicosbancarios',
          fallbackLabel: 'Históricos Bancários',
          icon: DescriptionIcon,
          to: '/financas/historicosbancarios'
        },
        {
          key: 'tiposdocumentos',
          fallbackLabel: 'Tipos de Documentos',
          icon: DescriptionIcon,
          to: '/financas/tiposdocumentos'
        },
        {
          key: 'contascorrentes',
          fallbackLabel: 'Contas Correntes',
          icon: AccountBalanceWalletIcon,
          to: '/financas/contascorrentes'
        },
        {
          key: 'transacoes',
          fallbackLabel: 'Transações',
          icon: ReceiptIcon,
          to: '/financas/transacoes'
        },
        {
          key: 'bancos',
          fallbackLabel: 'Bancos',
          icon: AccountBalanceIcon,
          to: '/financas/bancos'
        },
        {
          key: 'setores',
          fallbackLabel: 'Setores',
          icon: BusinessIcon,
          to: '/financas/setores'
        },
        {
          key: 'feriados',
          fallbackLabel: 'Feriados',
          icon: EventIcon,
          to: '/financas/feriados'
        },
        {
          key: 'paises',
          fallbackLabel: 'Países',
          icon: PublicIcon,
          to: '/financas/paises'
        }
      ]
    },
    {
      key: 'fechamento',
      fallbackLabel: 'Fechamento Financeiro',
      icon: MonetizationOnIcon,
      children: [
        {
          key: 'fechamentofinanceiro',
          fallbackLabel: 'Executar Fechamento',
          icon: QueueOutlinedIcon,
          to: '/financas/fechamentofinanceiro'
        },
        {
          key: 'fechamentosfinanceiros',
          fallbackLabel: 'Histórico de Fechamentos',
          icon: FormatListBulletedRoundedIcon,
          to: '/financas/fechamentosfinanceiros'
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ],

  [AMODULO_CRM]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlinedIcon,
      to: '/crm/dashboard'
    },
    {
      key: 'whatsapp',
      fallbackLabel: 'WhatsApp',
      icon: ForumIcon,
      children: [
        {
          key: 'grupos-msg-whatsapp',
          fallbackLabel: 'Grupos de Mensagens',
          icon: GroupIcon,
          to: '/crm/grupomsgwhatsappfornecedor'
        },
        {
          key: 'msg-whatsapp',
          fallbackLabel: 'Mensagens',
          icon: MessageIcon,
          to: '/crm/msgwhatsappfornecedor'
        },
        {
          key: 'envio-whatsapp',
          fallbackLabel: 'Envio',
          icon: SendIcon,
          to: '/crm/enviowhatsappfornecedor'
        },
        {
          key: 'chat-whatsapp',
          fallbackLabel: 'Chat',
          icon: ChatIcon,
          to: '/crm/chatwhatsapp'
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ],

  [AMODULO_ADMAPPCLI]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlinedIcon,
      to: '/admappcli/dashboard'
    },
    {
      key: 'passageiros',
      fallbackLabel: 'Sisare Passenger',
      icon: PeopleIcon,
      children: [
        {
          key: 'adm-sisare-passenger-list',
          fallbackLabel: 'Passageiros',
          icon: PeopleIcon,
          to: '/admappcli/adm-sisare-passenger-list'
        }
      ]
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ],
  
  [AMODULO_PARTNER]: [
    {
      key: 'dashboard',
      labelKey: 'MENU_DASHBOARD',
      fallbackLabel: 'Dashboard',
      icon: DashboardOutlinedIcon,
      to: '/admpartner/dashboard'
    },
    {
      key: 'agenda',
      fallbackLabel: 'Agenda Escala Fornecedor',
      icon: ScheduleIcon,
      to: '/admpartner/agendaescalafornecedor'
    },
    {
      key: 'usuarios-partner',
      fallbackLabel: 'Usuários Partner',
      icon: GroupWorkOutlinedIcon,
      to: '/admpartner/usuariopartner'
    },
    {
      key: 'logout',
      labelKey: 'MENU_ITEM_SAIR',
      fallbackLabel: 'Sair',
      icon: ExitToAppRoundedIcon,
      to: '/logout'
    }
  ]
};

/**
 * Helpers opcionais
 */
export const getRoutesByModule = (moduleCode) =>
  appRoutes.filter(route => route.moduleCode === moduleCode);

export const getMenuByModule = (moduleCode) =>
  menuByModule[moduleCode] || [];